import * as React from 'react';
import axios from 'axios';
import YttHeader from './header/header';
import YttFooter from './footer/footer';
import Magazine from './magazine/magazine';
import Library from './library/library';
import Search from './search/search';

import ErrorBoundary from './errorboundary/errorboundary';
import { Helmet } from 'react-helmet';
import { IntlProvider, addLocaleData } from "react-intl";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import en from "react-intl/locale-data/en";
import de from "react-intl/locale-data/de";
import fr from "react-intl/locale-data/fr";
import ar from "react-intl/locale-data/ar";
import ja from "react-intl/locale-data/ja";
import messages_de from "./translations/de.json";
import messages_en from "./translations/en.json";
import messages_fr from "./translations/fr.json";
import messages_ar from "./translations/ar.json";
import messages_ja from "./translations/ja.json";
import locations_de from "./locations/de.json";
import locations_en from "./locations/en.json";
import locations_fr from "./locations/fr.json";
import locations_ar from "./locations/ar.json";
import locations_ja from "./locations/ja.json";
import './App.scss';

library.add(faSync);

addLocaleData([...en, ...de, ...fr, ...ar, ...ja]);

const locations = {
  'ar': locations_ar,
  'fr': locations_fr,
  'de': locations_de,
  'ja': locations_ja,
  'en': locations_en
};

const translations = {
  'ar': messages_ar,
  'fr': messages_fr,
  'de': messages_de,
  'ja': messages_ja,
  'en': messages_en
};

class App extends React.Component {
  constructor(props) {
    super(props);

    // Bind the this context to the handler functions
    this.toggleOverlayState = this.toggleOverlayState.bind(this);
    this.changeRoute = this.changeRoute.bind(this);
    this.issueMenuHandler = this.issueMenuHandler.bind(this);
    this.langMenuHandler = this.langMenuHandler.bind(this);
    this.overlayHandler = this.overlayHandler.bind(this);
    this.ctaHandler = this.ctaHandler.bind(this);

    // Set app state
    this.state = {
      seoTitle: "Your Tomorrow, Today",
      fullPath: this.getFullUrl(),
      basePath: this.getBasePath(),
      issues: [],
      articles: [],
      loadedIssue: {},
      loadedArticle: {},
      locale: "",
      geoLocale: "",
      browserLocale: this.props.localeBrowser,
      urlLocale: this.props.localeUrl,
      location: {},
      langDirection: this.getLangDirection(this.props.localeUrl),
      locationMap: locations,
      locationUrl: "https://www.oracle.com/visitorinfo/",
      locationLoaded: false,
      resourceDomain: "",
      latestIssueId: "",
      activePage: this.props.urlPage,
      activeIssueId: this.props.urlIssue,
      activeArticleId: this.props.urlArticle,
      issueHeroFixed: true,
      overlayActive: false,
      issueMenuOpen: false,
      langMenuOpen: false,
      reloadRequired: false,
      isLoading: false,
      isLoaded: false,
      languageResolved: false,
      error: null,
      failedIssueLoadCount: 0,
      showCtaDownload: false,
      overlayCtaActive: false,
      ctaLocalizedUrl: "",
      theEnvironment: "",
      baseUrl: "."
    };
  }

  getLangDirection(langCode) {
    let returnLangDir = "left-right";
    if(!langCode) {
      return returnLangDir;
    }
    if(langCode === "ar"){
      returnLangDir = "right-left";
    }
    return returnLangDir;
  }

  // loading functions

  //load the location service to geolocate the user
  loadLocationObject() {
    let locationServiceUrl = this.state.locationUrl;
    this.setState({ locationLoaded: false }, function(){
      axios.get(locationServiceUrl)
      .then(result => {
        this.setState({
        location: result.data,
        locationLoaded: true,
        }, this.languageResolver(result.data));
      })
      .catch(error => this.setState({
        error,
        locationLoaded: false,
        location: {
          "country_code": "GB",
          "region_code": "EN",
          "continent_code": "EU",
          "timezone": "GMT",
          "georegion": "2"
        }
      }, this.languageResolver({"country_code": "GB","region_code": "EN","continent_code": "EU","timezone": "GMT","georegion": "2"})));
    });
  }

  //load article data from the correct translation folder
  loadArticle(articleToLoad) {
    if(!articleToLoad) {
      return;
    }
    let articleIndex = this.state.baseUrl+'/json-data/translations/'+this.state.locale+'/articles/'+articleToLoad+'.json';
    this.setState({ isLoading: true });
    axios(articleIndex)
      .then(result => {
        this.setState({
        loadedArticle: result.data,
        isLoading: false,
        reloadRequired: false,
        isLoaded: true,
        });
      })
      .catch(error => this.setState({
        error,
        reloadRequired: false,
        isLoading: false
      }));
  }

  //load issue data from the correct translation folder
  loadIssue(issueToLoad) {
    if(!issueToLoad) {
      return;
    }
    //let langFolder = this.state.locale === "" ? this.state.urlLocale : this.state.locale;
    let issueIndex = this.state.baseUrl+'/json-data/translations/'+this.state.locale+'/issues/'+issueToLoad+'.json';

    this.setState({ isLoading: true, reloadRequired: false },
        function() {
          axios.get(issueIndex)
          .then(result => {
            this.setState({
              loadedIssue: result.data,
              activeIssueId: result.data.issueId,
              articles: result.data.issueArticles,
              isLoading: false,
              isLoaded: true,
              reloadRequired: false,
              failedIssueLoadCount: 0
            });
          })
          .catch(error => this.setState({
            error,
            failedIssueLoadCount: 1,
            reloadRequired: false,
            isLoading: false
          }));
        }
      );
  }

  //load all issues data from the correct translation folder
  loadIssues() {
    console.log(this.state.locale);
    let issueIndex = this.state.baseUrl+'/json-data/translations/'+this.state.locale+'/issues.json';
    this.setState({ isLoading: true, reloadRequired: false }, function() {
      axios.get(issueIndex)
      .then(result => {
        this.setState({
          issues: result.data.issues,
          seoTitle: result.data.siteSeoTitle,
          latestIssueId: result.data.featureIssueId,
          isLoading: false,
          reloadRequired: true
        }, function(){
        });
      })
      .catch(error => this.setState({
        error,
        isLoading: false
      }));
    });
  }

  loadMagazine() {
    var issueToLoad = "";
    var articleToLoad = this.state.activeArticleId;
    var activeIssueId = this.state.activeIssueId;

    if(this.state.activeIssueId === "" || typeof(this.state.activeIssueId) === "undefined") {
      issueToLoad = this.state.latestIssueId ? this.state.latestIssueId : this.props.urlIssue;
    } else {
      issueToLoad = activeIssueId;
    }

    if((issueToLoad !== "" && typeof(issueToLoad) !== "undefined" && issueToLoad !== "undefined") && this.state.reloadRequired === true) {
      //console.log("Loading Issue: " + issueToLoad);
      this.loadIssue(issueToLoad);
    }
    
    if((articleToLoad !== "" && typeof(articleToLoad) !== "undefined" && articleToLoad !== "undefined") && this.state.reloadRequired === true) {
      //console.log("Loading Article: " + articleToLoad);
      this.loadArticle(articleToLoad);
    }
  }

  changeRoute(issueId, articleId, page) {
    console.log("changeRoute issue:" + issueId + " article: " + articleId + " page: " + page);
    let tmpReloadRequired = false;
    issueId = issueId ? issueId : "";
    page = page ? page : "";
    articleId = articleId ? articleId : "";

    if(issueId === "" && page === "" && articleId === "") {
      return;
    }

    if( issueId !== this.state.activeIssueId || articleId !== this.state.activeIssueId ) {
      tmpReloadRequired = true;
    }

    if(articleId !== "") {
      this.setState({
        activePage: page,
        activeIssueId: issueId,
        activeArticleId: articleId,
        reloadRequired: tmpReloadRequired
      }, function() {
        this.overlayHandler();
        if(this.state.loadedArticle.articleType === "video"){
          //force js reload to hack video update / need to find a better way to do this.
          window.location.reload(false); 
        }
      });
    } else {
      this.setState({
        activePage: page,
        activeIssueId: issueId,
        activeArticleId: articleId,
        reloadRequired: tmpReloadRequired,
        loadedArticle: {}
      }, function() {
        this.overlayHandler();
        if(this.state.loadedArticle.articleType === "video"){
          //force js reload to hack video update / need to find a better way to do this.
          window.location.reload(false); 
        }
      });
    }
  }

  languageResolver(langObject) {
    if(!langObject) {
        return;
    }

    //set tmplocale to geolocation language
    let tmpGeoLocalMap = langObject.country_code;
    let tmpLocale = this.state.locale;
    let tmpUrlLocale = this.state.urlLocale;
    let tmpBrowserLocale = this.state.browserLocale;
    let tmpLanguage = tmpUrlLocale ? tmpUrlLocale : tmpBrowserLocale;
    tmpLanguage = tmpLanguage.toLowerCase();

    //console.log("tmpGeoLocal: "+ tmpGeoLocalMap + " tmpLocale: "+ tmpLocale + " tmpUrlLocale: "+ tmpUrlLocale + " tmpBrowserLocale: "+ tmpBrowserLocale + " tmpLanguage: "+ tmpLanguage);

    //set locale based on language 
    if(this.state.locationMap[tmpLanguage]) {
      if(this.state.locationMap[tmpLanguage][tmpGeoLocalMap]) {
        tmpLocale = this.state.locationMap[tmpLanguage][tmpGeoLocalMap].langCode ? this.state.locationMap[tmpLanguage][tmpGeoLocalMap].langCode : "";
      }
    }
    
    tmpLocale = tmpLocale.toLowerCase();

    //if we have a url locale use that above all otherwise use geo locale
    if (this.state.urlLocale === "en" || this.state.urlLocale === "fr" || this.state.urlLocale === "ar" || this.state.urlLocale === "de" || this.state.urlLocale === "ja"){
      tmpLocale = this.state.urlLocale;
    } 

    // if tmlLocale is still empty fall back to browser Locals
    if( tmpLocale === "" ) {
      tmpLocale = this.state.browserLocale;
    }

    // if tmlLocale is still empty fall back to en
    if( tmpLocale === "" ) {
      tmpLocale = "en";
    }

    console.log("tmpLanguage: "+ tmpLanguage);

    this.setState({
      geoLocale: tmpGeoLocalMap,
      locale: tmpLocale,
      langDirection: this.getLangDirection(tmpLocale),
      languageResolved: true
    }, function() {
      this.loadIssues();
      this.setState({
        fullPath: this.getFullUrl()
      });
    });
  }

  issueMenuHandler() {
    if(!this.state.issueMenuOpen) {
      this.openIssueMenu();
    } else {
      this.closeIssueMenu();
    }
  }

  langMenuHandler() {
    if(!this.state.langMenuOpen) {
      this.openLangMenu();
    } else {
      this.closeLangMenu();
    }
  }

  overlayHandler() {
    if(this.state.issueMenuOpen) {
      this.closeIssueMenu();
    }
    if(this.state.langMenuOpen) {
      this.closeLangMenu();
    }
  }

  ctaHandler(localizedUrl) {
    if(this.state.showCtaDownload) {
      this.setState({
        ctaLocalizedUrl: "",
        showCtaDownload: false,
        overlayCtaActive: false
      });
    } else {
      this.setState({
        ctaLocalizedUrl: localizedUrl,
        showCtaDownload: true,
        overlayCtaActive: true
      });
    }
  }

  openIssueMenu() {
    this.setState({
      langMenuOpen: false,
    });
    this.setState({
      issueMenuOpen: true,
      overlayActive: true
    });
  }
  
  closeIssueMenu() {
    this.setState({
      issueMenuOpen: false,
      overlayActive: false
    });
  }

  openLangMenu() {
    this.setState({
      issueMenuOpen: false,
    });
    this.setState({
      langMenuOpen: true,
      overlayActive: true
    });
  }
  
  closeLangMenu() {
    this.setState({
      langMenuOpen: false,
      overlayActive: false
    });
  }

  closeActiveOverlayState() {
    this.setState({
      overlayActive: false
    });
  }

  openActiveOverlayState() {
    this.setState({
      overlayActive: true
    });
  }

  toggleOverlayState() {
      if(!this.state.overlayActive) {
        this.setState({
          overlayActive: true
        });
      } else {
        this.setState({
          overlayActive: false
        });
      }
  }

  goTopOfPage() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  getFullUrl() {
    return window.location.href;
  }

  getBasePath() {
    return window.location.protocol + window.location.host;
  }

  componentDidMount() { 
    //console.log("componentDidMount");
    this.goTopOfPage();
    this.loadLocationObject();
  }


  componentDidUpdate() {
    //check if reload magazine required and then load it
    if (this.state.reloadRequired === true) {
      this.goTopOfPage();
      this.loadMagazine();
      this.setState({
        fullPath: this.getFullUrl()
      });
    }
  }

  pageSwitch() {
    switch(this.state.activePage) {
      case "library":
        return <Library state={this.state} changeRoute={this.changeRoute} overlayHandler={this.overlayHandler} ctaHandler={this.ctaHandler}/>
      case "search":
        return <Search state={this.state} changeRoute={this.changeRoute} overlayHandler={this.overlayHandler} ctaHandler={this.ctaHandler}/>
      default:
        return <Magazine state={this.state} changeRoute={this.changeRoute} overlayHandler={this.overlayHandler} ctaHandler={this.ctaHandler}/>
    } 
  }

  render() {
    if(!this.state.languageResolved) {
      return (
        <div className="loadingContnet">
          <h2><FontAwesomeIcon icon="sync" className="fa-spin"/> Loading please wait </h2>
        </div>
      )
    } else {
    return (
      <IntlProvider locale={this.state.locale} messages={translations[this.state.locale]}>
        <>
        <div id="YttMagazine" className={"overlay " + (this.state.overlayActive ? 'overlay-on' : 'overlay-off') + " " + this.state.langDirection}>
          <ErrorBoundary>
            <Helmet htmlAttributes={{ lang : this.state.locale }}/>
            <Helmet>
              <title>{this.state.seoTitle + " - " + this.state.loadedIssue.issueTitle}</title>
              <meta name="description" content={this.state.loadedIssue.issueSummary} />
              <meta property="og:title" content={this.state.seoTitle + " - " + this.state.loadedIssue.issueTitle}/>
              <meta property="og:description" content={this.state.loadedIssue.issueSummary}/>
              <meta property="og:image" content={this.state.basePath + this.state.loadedIssue.issueThumbnail}/>
              <meta property="og:url" content={this.state.fullPath}/>
              <meta property="og:site_name" content={this.state.seoTitle}/>
              <meta name="twitter:card" content="summary_large_image"/>
            </Helmet>
          </ErrorBoundary>
          <ErrorBoundary>
            <YttHeader state={this.state} changeRoute={this.changeRoute} issueMenuHandler={this.issueMenuHandler} langMenuHandler={this.langMenuHandler}/>
          </ErrorBoundary>
          <ErrorBoundary>
              {this.pageSwitch()}         
          </ErrorBoundary>
          <ErrorBoundary>
            {this.state.activePage !== "library" && <YttFooter state={this.state} changeRoute={this.changeRoute}/>}
          </ErrorBoundary>
        </div>
        <div className={this.state.overlayCtaActive ? "cta-overlay show-overlay" : "cta-overlay"} onClick={() => this.ctaHandler("")}>
            {this.state.showCtaDownload &&
                <div id="report_download" className="modal fade show" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <iframe id="report-cta-download" 
                                title="CTA Download" 
                                className="embed-responsive-item" 
                                src={this.state.ctaLocalizedUrl}>
                                </iframe>
                            </div>
  
                        </div>
                    </div>
                </div>
            }
          </div>
          <style>{".card a.card-link .is-video:after {background-image:url(" + this.props.baseUrl + "/images/bcg-play-btn.png);"}</style>
        </>
      </IntlProvider>
    );
  }
}
}

export default App;
